"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const lodash_1 = require("lodash");
const core_1 = require("companion-app-components/utils/core");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MoreVertRounded_1 = __importDefault(require("@mui/icons-material/MoreVertRounded"));
const mui_1 = require("tss-react/mui");
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QMenuList_1 = __importDefault(require("components/QMenu/QMenuList"));
const style_1 = require("./style");
const log = (0, core_1.getLogger)('components/QuickenControls/QMenu/index.tsx');
const useStyles = (0, mui_1.makeStyles)()(style_1.style);
let idCounter = 1;
const QMenu = React.forwardRef((props, ref) => {
    const { classes, theme } = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [value, setValue] = React.useState(null);
    const [extraId, setExtraId] = React.useState(null);
    const [anchorHover, setAnchorHover] = React.useState(null);
    const [myId, setMyId] = React.useState(idCounter);
    const menuRef = React.useRef(null);
    React.useEffect(() => {
        idCounter += 1;
        setMyId(idCounter);
    }, []);
    const open = Boolean(anchorEl) || Boolean(props.open);
    const myLog = React.useCallback((...args) => {
        log.debug('QMenu', props.name, args);
    }, [props]);
    // request to close this menu
    const handleRequestClose = React.useCallback(() => {
        myLog('REQUEST CLOSE', props.name);
        setAnchorEl(null);
        if (props.onClose) {
            props.onClose();
        }
    }, [props, myLog]);
    const onChange = (newValue, newExtraId, noClose) => {
        if (noClose) {
            props.onChange(newValue, newExtraId, noClose);
        }
        else {
            setValue(newValue);
            setExtraId(newExtraId);
            if (!noClose) {
                handleRequestClose();
            }
        }
    };
    const onEntered = () => {
        var _a;
        const e = document.getElementById(`long-menu-wrapper_${myId}`);
        menuRef.current = e;
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        myLog('MENU ENTERED', myId);
    };
    const onExiting = () => {
        menuRef.current = null;
    };
    const onExited = () => {
        myLog('EXITED ', props.name, value);
        if (props.onChange && value !== null) {
            props.onChange(value, extraId);
        }
        setValue(null);
        setExtraId(null);
        setAnchorHover(null);
        setAnchorEl(null);
    };
    // mouse left the icon/trigger for opening a submenu
    const mouseLeftSubMenuTrigger = () => {
        setTimeout(() => {
            setAnchorEl(null);
        }, 500);
    };
    // item from this menu was clicked on
    const handleClick = React.useCallback((menuValue, menuExtraId, noClose) => {
        if (noClose && props.onChange) {
            props.onChange(menuValue, menuExtraId, noClose);
            return;
        }
        setValue(menuValue);
        setExtraId(menuExtraId);
        handleRequestClose();
    }, [props, handleRequestClose]);
    // show this menu (the trigger was clicked or hovered)
    const initMenu = (event, delay = false) => {
        const target = event.currentTarget;
        event.stopPropagation();
        if (delay) {
            setTimeout(() => setAnchorEl(target), 500);
        }
        else {
            setAnchorEl(target);
        }
    };
    React.useImperativeHandle(ref, () => ({
        initMenu,
    }));
    const buttonRefFunc = (x) => {
        if (open) {
            setAnchorEl(x);
        }
        if (props.buttonRef) {
            props.buttonRef(x);
        }
    };
    const debounceHover = (0, lodash_1.debounce)((currTarget) => setAnchorHover(currTarget), 100);
    const hover = React.useCallback((e) => {
        const currTarget = e.currentTarget;
        debounceHover(currTarget);
    }, [debounceHover]);
    const MenuIcon = !open ? (props.menuIcon || MoreVertRounded_1.default) : (props.menuCloseIcon || props.menuIcon || MoreVertRounded_1.default);
    const subMenuStyle = props.openOnHover ? classes.subMenu : {};
    const listItemsData = React.useMemo(() => props === null || props === void 0 ? void 0 : props.options.map((item) => <QMenuList_1.default key={`qmenulist_item_${JSON.stringify(item.value)}_${item.label}`} item={item} subMenuType={QMenu} hover={hover} subMouseEntered={props.subMouseEntered} onChange={onChange} classes={classes} anchorHover={anchorHover} name={props.name} handleClick={handleClick} theme={theme} checkIconClassName={props.checkIconClassName}/>), [props.options, props.subMouseEntered, classes, anchorHover, props.name, theme, handleClick, hover, props.checkIconClassName]);
    return (<>
      {props.customTrigger &&
            <QTip_1.default title={props.title}>
          <ButtonBase_1.default onClick={initMenu} ref={(x) => buttonRefFunc(x)} id={`qmenu_open_${props.name}`} autoFocus={props.autoFocus} focusRipple className={props.customTriggerClass || ''}>
            {props.customTrigger}
          </ButtonBase_1.default>
        </QTip_1.default>}
      {!props.customTrigger &&
            <div onMouseEnter={props.openOnHover ? (e) => initMenu(e, true) : undefined} onMouseLeave={props.openOnHover ? mouseLeftSubMenuTrigger : undefined} style={Object.assign(Object.assign({}, subMenuStyle), props.menuStyle)}>
          <QTip_1.default title={props.title}>
            <QIconButton_1.default id={`qmenu_open_${props.name}`} aria-label="More" aria-owns={open ? `long-menu_${myId}` : null} aria-haspopup="true" onClick={initMenu} component="div" size={props.menuIconButtonSize || null} autoFocus={props.autoFocus}>
              <MenuIcon className={classes.iconColor}/>
            </QIconButton_1.default>
          </QTip_1.default>
        </div>}

      <div onMouseEnter={props.subMouseEntered}>
        <Menu_1.default className={classes.menuItem} id={`long-menu_${myId}`} open={open} anchorEl={anchorEl || anchorEl} anchorOrigin={props.anchorOrigin || { horizontal: 'right', vertical: 'bottom' }} transformOrigin={props.transformOrigin || { horizontal: 'left', vertical: 'top' }} onKeyDown={(e) => {
            if (['Enter', 'Escape', 'ArrowUp', 'ArrowDown', 'Tab'].includes(e.key)) {
                e.stopPropagation();
            }
            if (e.key === 'Escape') {
                handleRequestClose();
            }
        }} PaperProps={{
            id: `long-menu-wrapper_${myId}`,
            className: classes.paperStyling,
        }} onBackdropClick={(e) => {
            e.stopPropagation();
            handleRequestClose();
            e.preventDefault();
        }} TransitionProps={{
            onExited,
            onExiting,
            onEntered,
        }}>
          {listItemsData}
        </Menu_1.default>
      </div>
    </>);
});
exports.default = QMenu;
